<template>
  <div>
    <!-- <el-popover
        placement="top-start"
        :width="340"
        trigger="hover"
        :open-delay="700"
    >
      <User-Infor-Card :data="curent_data" type="small" @opendialog="$refs.dialog.isLogin()">
      </User-Infor-Card> -->
    <!-- <template #reference> -->
    <div class="d-flex hot-group" id="author">
      <!--      wxc-->
      <a v-if="$store.state.user.check_is_wxc_domain()" target="_blank" :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username" >
        <div>
          <el-avatar :size="55" :src="curent_data.userinfo_userID.avatar"> {{
              curent_data.userinfo_userID.first_letter
            }}
          </el-avatar>
        </div>
      </a>
      <!--      hw-->
      <a v-if="$store.state.user.check_is_wxc_domain()" target="_blank" :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username"></a>
      <router-link v-else
          :to="'/userindex/'+curent_data.userID">
        <div>
          <el-avatar :size="55" :src="curent_data.userinfo_userID.avatar"> {{
              curent_data.userinfo_userID.first_letter
            }}
          </el-avatar>
        </div>
      </router-link>
      <div class='align-self-center right pl-2 flex-grow-1'>
        <div class="d-flex align-self-center justify-content-between">
          <div class='small-name'>
            <span v-if="type==='host'">
              <el-tag class="mr-2" size="medium">群主</el-tag>
            </span>
            <span v-if="type==='admin'">
              <el-tag class="mr-2" size="medium">管理员</el-tag>
            </span>
            <span  v-if="type==='default'" >
              <el-tag class="mr-2" size="medium">群员</el-tag>
            </span>
            <a v-if="$store.state.user.check_is_wxc_domain()" target="_blank"
               :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username">
              <span v-if="usertype!=='search'">{{ curent_data.userinfo_userID.username }}</span>
            </a>
            <router-link v-else
                :to="'/userindex/'+curent_data.userID">
            <span v-if="usertype!=='search'">{{ curent_data.userinfo_userID.username }}</span>
            </router-link>
<!--            <span v-if="usertype==='search'" class="text-muted">-->
<!--                  <span v-html="curent_data.username" style="color:#14171a;"></span>-->
<!--                  <span style="font-size:24px;font-weight:300;padding:0 14px">|</span>群吧名：-->
<!--              <span v-html="curent_data.name">-->
<!--              </span>-->
<!--            </span>-->
            <!--                对成员的操作-->
          </div>
          <div>
<!--          <div v-if="is_admin">-->
          <div v-if="$store.state.group.groupTopBar.auth>=3">
            <div  v-if="type==='admin'">
              <el-dropdown trigger="click">
              <span class="el-dropdown-link">
              <i size="medium"  style="font-size: 18px" class="el-icon-more"></i>
            </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="type==='admin'">
                    <a href="javascript:void(0)" style="color:gray;display: block" @click="member_update(curent_data.userID,1)">
                      <i size="medium" class="el-icon-user"></i>
                      撤销管理员权限
                    </a>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="type==='default'">
                    <a href="javascript:void(0)" style="color:gray;display: block" @click="member_update(curent_data.userID,2)">
                      <i size="medium" class="el-icon-user"></i>
                      设置为管理员
                    </a>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-popconfirm
                        placement="top-end"
                        confirm-button-text='删除'
                        cancel-button-text='取消'
                        title="确定删除此成员吗？"
                        :hide-icon="true"
                        @confirm="member_update(curent_data.userID,0)">
                    >
<!--                      @confirm="member_remove(curent_data.userID)"-->
                      <a href="javascript:void(0)" slot="reference" style="color:gray;display: block;letter-spacing:3px">
                        <i size="medium" class="el-icon-delete"></i>
                        删除此成员
                      </a>
                    </el-popconfirm>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div  v-if="$store.state.group.groupTopBar.auth>=2">
            <div  v-if="type==='member'">
              <el-dropdown trigger="click">
              <span class="el-dropdown-link">
              <i size="medium" style="font-size: 18px" class="el-icon-more"></i>
            </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  v-if="$store.state.group.groupTopBar.auth>=3">
                    <a href="javascript:void(0)" style="color:gray;" @click="member_update(curent_data.userID,2)">
                      <i size="medium" class="el-icon-user"></i>
                      设置为管理员
                    </a>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2">
                    <el-popconfirm
                        placement="top-end"
                        confirm-button-text='删除'
                        cancel-button-text='取消'
                        title="确定删除这个成员吗？"
                        :hide-icon="true"
                        @confirm="member_update(curent_data.userID,0)">
                    >
<!--                      @confirm="member_remove(curent_data.userID)"-->
                      <a href="javascript:void(0)" slot="reference" style="color:gray;">
                        <i size="medium" class="el-icon-delete"></i>
                        删除此成员
                      </a>
                    </el-popconfirm>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          </div>
          <div v-if="type==='verify'&& $store.state.group.groupTopBar.auth>=2">
<!--          <div v-if="type==='verify' && ($store.state.group.groupTopBar.auth>=2 || $store.state.user.userinfo.UserLevel==6)">-->
            <el-button style="padding: 5px 4px;" size="mini" type="primary" icon="el-icon-check"
                       @click="member_update(curent_data.userID,1)">
              批准
            </el-button>
            <el-button class="ml-3 plain" type="text" slot="reference" @click="member_update(curent_data.userID,0)">
              <i class="el-icon-close"
                 style="color:#dc3545"></i><span style="padding: 1px 0px;color:#333">拒绝</span>
            </el-button>
            <!-- </el-tooltip> -->
          </div>
          <div v-if="type==='default'">
            <a v-if="!curent_data.userinfo_userID.is_following" class="btn btn-link text-primary w-100 btn-follow"
               @click="following_add(curent_data.userID)">
              <div class="d-flex justify-content-end align-items-center add">
                <!-- <icon-plus></icon-plus> -->
                {{ $t('message').blog.blogger_follow }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- </template> -->
    <!-- <login-dialog ref="dialog"></login-dialog> -->
    <!-- </el-popover> -->
  </div>
</template>
<script>
import {Button,} from '@/components';
import account from '../../../../user/user.service';
import group from '@/module/group/group.service';

export default {
  name: 'member-list-item',
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Alert type'
    },
    data: {
      userID: Number,
      count_follower: Number,
      count_buzz: Number,
      userinfo_userID: {
        id: Number,
        username: String,
        verified: Number,
        status: Number,
        first_letter: String,
        is_hot_blogger: Number,
        is_following: Number
      }
    },
    usertype: String
  },
  computed: {
    not_member() {
      let fb = true
      if (!this.userID) {
        fb = true
      }
      this.groupState.memberLists.forEach(x => {
        if (this.userID === x.userID) {
          fb = false
        }
      });
      return fb
    },
    is_admin() {
      let fb = false;
      if (this.groupState.memberList.data.host) {
        this.groupState.memberList.data.host.map(x => {
          if (this.userID === x.userID) {
            fb = true
          }
        });
        this.groupState.memberList.data.admin.map(x => {
          if (this.userID === x.userID) {
            fb = true
          }
        });
      }
      return fb
    },
  },
  components: {
    [Button.name]: Button,
    // IconPlus,
    // IconCheck,
    // IconX,
    // LoginDialog,
    // UserInforCard
  },
  created: function () {
    let userinfor = this.$store.state.user.userinfo;
    this.loginuserID = userinfor ? userinfor.UserID : -1;
    if (this.usertype == "follower") {
      this.curent_data.userinfo_userID = this.data.userinfo_followerID;
      this.curent_data.userID = this.data.userinfo_followerID.id;
    };
    this.domain = location.host;
  },
  methods: {
    following_add(id){
      if(!this.check_user_login())  return;
      account.following_add(id).then(res => {
        if (res.status) {
          this.curent_data.userinfo_userID.is_following = 1;
          this.$message.success('已成功关注')
        } else {
          this.$message.error(res.error);
        }
      });
    },
    member_update(userID, status) {
      group.member_update(this.groupID, userID, status).then(res => {
        if (res.status) {
          this.$store.dispatch('group/getMemberList', {
            groupID: this.groupID,
            // lastID: this.$store.state.group.memberList.lastID
            lastID:0,
          });
          this.$message.success('操作成功!')
          } else {
            this.$message.warning(res.error);
          }
      })
    },
    member_remove(userID) {
      this.$store.dispatch('group/removeMember', {groupinfoID: this.groupID, userID: userID}).then(res => {
        this.$store.dispatch('group/getGroupTopBar', this.groupID);
        this.$store.dispatch('group/getMemberList', {
          groupID: this.groupID,
          // lastID: this.$store.state.group.memberList.lastID
          lastID:0
        });
      })
    },
    getCountryName() {
      return localStorage.lang === 'cns' ? this.curent_data.userinfo_userID.country_flag.cns : this.curent_data.userinfo_userID.country_flag.cnt
    },
    following_delete(id){
      if(!this.check_user_login())  return;
      account.following_delete(id).then(res => {
        if (res.data == true) {
          this.curent_data.userinfo_userID.is_following = 0;
        } else {
          this.$message.error(res.error);
        }
      });
    },
  },
  data() {
    return {
      userID: this.$store.state.user.userinfo.id,
      groupState: this.$store.state.group,
      groupID: this.data.groupinfoID,
      loginuserID: -1,
      error: '',
      curent_data: this.data
    }
  },
  watch: {
    data(val) {
      this.curent_data = val
    }
  }
}

</script>
<style>
.el-dialog__header {
  padding: 20px!important;
}
.hot-group {
  padding: 12px 2px;
  border-bottom: 1px solid #ebeef0;
}

.hot-group.noborder {
  border-top: 0;
}

.hot-group a {
  color: #14171a;
  text-decoration: none;
}

.hot-group a:hover {
  color: #235592
}

.hot-group .description a {
  color: #657786
}
.hot-group-avatar .avatar-word, .small .avatar-word {
  border-radius: 50%;
  background-color: #eeeeee;
  line-height: 48px;
  text-align: center;
  font-weight: 500;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset
}

.hot-group-avatar .avatar-word, .small .avatar-word:hover {
  background-color: #eeeeee;
}

.hot-group-avatar .avatar-word {
  min-width: 48px
}

.hot-group .small .lable {
  position: absolute;
  margin-left: 20px;
  margin-top: -14px;
  transform: rotate(33deg)
}

.hot-group-avatar .lable {
  position: absolute;
  margin-left: 28px;
  margin-top: -14px;
  transform: rotate(27deg)
}

.hot-group-avatar {
  width: 48px
}

.hot-group-avatar .rounded-circle, .hot-group-avatar .avatar-word:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}

.small {
  width: 36px;
}

.hot-group-avatar img {
  min-width: 48px;
  height: 48px;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;

}

.small img {
  width: 36px;
  height: 36px;
}

.small .avatar-word {
  width: 38px;
  height: 38px;
  line-height: 38px;
  font-size: 1rem;
}

.blogger-name {
  font-size: 1rem;
  font-weight: 600;

}

.blogger-name span {
  color: #333
}

.small-name {
  font-size: .95rem;
  font-weight: 600;
  line-height: 38px;

}

.cancel-follow span.cancel-text, .cancel-follow:hover span.followed-text {
  display: none;
}

.cancel-follow span.followed-text, .cancel-follow:hover span.cancel-text {
  display: block;
}

.cancel-follow, .btn-follow {
  padding: 0;
}

.hot-group .right a {
  padding: 0;
}

.hot-group .right .btn {
  margin: 0;
}

.hot-group .right .btn .add {
  fill: #35abbb;
  font-size: 1rem;
}

.hot-group .right .btn:hover .add {
  fill: #236e85;
}

.hot-group .right .description {
  font-size: medium;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: 4px;
}

.el-popover.bubble {
  background-color: #14171a;
  color: white
}
.el-tag{
  font-size: 14px;
}

.el-popover.bubble .popper__arrow,
.el-popover.bubble .popper__arrow::after {
  border-top-color: #14171a;
  border-bottom-color: #14171a;
}

.el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after {
  display: none;
}

.el-tooltip__popper, .tooltip-inner {
  min-width: 32px !important;
}

@media (max-width: 575.98px) {
  .list-itme .list-itme-image {
    margin: auto 0;
    margin-left: .5rem;
  }

  .imgspace {
    width: 90px;
    height: 90px;
  }

  .hot-group {
    padding: 12px 0;
  }

  .hot-group .right .description {
    display: none;
  }

  .cancel-follow span.cancel-text.text-danger {
    display: block;
    color: #888 !important;
  }

  .cancel-follow span.followed-text {
    display: none;
  }
}
</style>